import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { DBAComponent } from '../component/dba.component';
import * as R from "ramda"
import { selectAccountsListItems } from '../../../../../redux/accounts/selector';
import { accounts } from '../../../../../redux/accounts/action';
import storePersist from '../../../../../redux/storePersist';
import { selectWebsitesListItems } from '../../../../../redux/websites/selector';
import { websites } from '../../../../../redux/websites/action';
import { selectDbasQueryItems } from '../../../../../redux/dbn-cloud/dbas/selector';
import { dbas } from '../../../../../redux/dbn-cloud/dbas/action';

const DBA = () => {
     var tenantId = storePersist?.get("guestTokenMetadata")?.current?.result?.TokenMetadata?.TenantId;
      const websitesItems = useSelector(selectWebsitesListItems)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectDbasQueryItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const accountItems = useSelector(selectAccountsListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [selectedDba, setSelectedDba] = useState<any>([])

  const fetchdbasById = () => {
    dispatch(dbas.query({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/dbas/fetch-detail`,
      entity: 'dbas',
      jsonData: {
        Context: {},
        Records: [
          {
            DBAId: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedDba({ ...selectedDba, [field]: event });
  }

  const handleFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedDba({ ...selectedDba, [fields[0]]: value });
  }

  useEffect(() => {
    dispatch(accounts.list({
      url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/rms/accounts/fetch`,
      entity: 'accounts',
      jsonData: {}
    })) .then(() => {
              dispatch(websites.list({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`,entity:'cards',jsonData:{
                   "Filters": [
                     {
                       "FieldName": "TenantId",
                       "FilterOperatorId": 1,
                       "FieldValue": tenantId,
                       "FieldType": "number"
                     }
                   ],
                   }}))
            })
      if (parmas?.id > 0) {
        fetchdbasById()
        setIsLoading(false)
      }
      else {
        setIsLoading(false)
      }
  }, []
  )

  useEffect(() => {
    if (isQuery) {
      setSelectedDba(queryItems?.result?.items)
    }
  }, [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(dbas.resetAction({ actionType: 'update' }))
      await dispatch(dbas.update({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/dbas`,
        entity: 'dbass',
        jsonData: {
          Context: {},
          Records: [
            {
              selectedDba
            }
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(dbas.resetAction({ actionType: 'create' }))
      await dispatch(dbas.create({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/dbas`,
        entity: 'dbass',
        jsonData: {
          Context: {},
          Records: [
            {
              selectedDba
            }
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate(-1)
  }

  return (
    <>
      {/* {queryItems?.isLoading || accountItems?.isLoading ? <PageLoader /> : */}
      {isLoading ? <PageLoader /> :
        <DBAComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedDba={selectedDba}
          back={back}
          handleFormSubmit={handleFormSubmit}
          handleFormChange={handleFormChange}
          accounts={accountItems?.result?.items}
          dbaId={parmas?.id}
          websites={websitesItems?.result?.items}
        />
      }
    </>
  )
}

export default DBA;
